// Which /ogs row drives a GLB character's face, and in what form.
//
// The face rig loader (faceRigDriver.js) wants an `orl_pack.bin`. The GASS
// plugin, publishing a MetaHuman from Unreal, has the character's `head.dna`
// but no way to bake the pack: the bake is `dnaToPack` (riglogic wasm), a
// browser-side conversion. So a freshly published character carries the DNA
// and the FIRST web load bakes the pack from it and writes the pack back into
// the same collection, after which every later load finds the pack directly.
//
// This is the pure decision: given the collection's rows, pick the pack when it
// exists, the DNA when only that does, nothing otherwise. The loader does the
// fetching, baking and write-back; a node:test can pin the rule without any
// of that.

import { ORL_PACK_FILE, orlAssetName } from './orl/bundleFiles.js'

/** The pack asset name the loader binds, `orl_pack.bin`. */
export const FACE_PACK_ASSET = orlAssetName(ORL_PACK_FILE)

/** The DNA asset name the GASS plugin uploads; the bake source. */
export const FACE_DNA_ASSET = 'head.dna'

/** A row's file name as the two API spellings deliver it. */
export const rowName = (row) => row?.filename ?? row?.name ?? null

/**
 * Normalise the list response (array, or an envelope with items/assets) into
 * an array of rows. Anything else is an empty list, which reads as `none`.
 */
export function rowsOf(response) {
  if (Array.isArray(response)) return response
  if (response && Array.isArray(response.items)) return response.items
  if (response && Array.isArray(response.assets)) return response.assets
  return []
}

/**
 * @param {any} response  the /ogs list response
 * @returns {{ kind: 'pack' | 'dna' | 'none', row: object | null }}
 */
export function pickFaceRigSource(response) {
  const rows = rowsOf(response)
  const pack = rows.find((r) => rowName(r) === FACE_PACK_ASSET)
  if (pack) return { kind: 'pack', row: pack }
  const dna = rows.find((r) => rowName(r) === FACE_DNA_ASSET)
  if (dna) return { kind: 'dna', row: dna }
  return { kind: 'none', row: null }
}
